/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LicenseSummary } from './LicenseSummary';
import {
    LicenseSummaryFromJSON,
    LicenseSummaryFromJSONTyped,
    LicenseSummaryToJSON,
    LicenseSummaryToJSONTyped,
} from './LicenseSummary';
import type { AttendanceSummary } from './AttendanceSummary';
import {
    AttendanceSummaryFromJSON,
    AttendanceSummaryFromJSONTyped,
    AttendanceSummaryToJSON,
    AttendanceSummaryToJSONTyped,
} from './AttendanceSummary';
import type { WorkshopBrief } from './WorkshopBrief';
import {
    WorkshopBriefFromJSON,
    WorkshopBriefFromJSONTyped,
    WorkshopBriefToJSON,
    WorkshopBriefToJSONTyped,
} from './WorkshopBrief';

/**
 * Usage numbers of the organization for its administrators.
 * @export
 * @interface OrganizationOverview
 */
export interface OrganizationOverview {
    /**
     * 
     * @type {number}
     * @memberof OrganizationOverview
     */
    students_active: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationOverview
     */
    staff_active: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationOverview
     */
    classes: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationOverview
     */
    workshops_this_week: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationOverview
     */
    workshops_next_week: number;
    /**
     * 
     * @type {AttendanceSummary}
     * @memberof OrganizationOverview
     */
    attendance_30d: AttendanceSummary;
    /**
     * 
     * @type {LicenseSummary}
     * @memberof OrganizationOverview
     */
    license: LicenseSummary;
    /**
     * 
     * @type {Array<WorkshopBrief>}
     * @memberof OrganizationOverview
     */
    recent_workshops?: Array<WorkshopBrief>;
}

/**
 * Check if a given object implements the OrganizationOverview interface.
 */
export function instanceOfOrganizationOverview(value: object): value is OrganizationOverview {
    if (!('students_active' in value) || value['students_active'] === undefined) return false;
    if (!('staff_active' in value) || value['staff_active'] === undefined) return false;
    if (!('classes' in value) || value['classes'] === undefined) return false;
    if (!('workshops_this_week' in value) || value['workshops_this_week'] === undefined) return false;
    if (!('workshops_next_week' in value) || value['workshops_next_week'] === undefined) return false;
    if (!('attendance_30d' in value) || value['attendance_30d'] === undefined) return false;
    if (!('license' in value) || value['license'] === undefined) return false;
    return true;
}

export function OrganizationOverviewFromJSON(json: any): OrganizationOverview {
    return OrganizationOverviewFromJSONTyped(json, false);
}

export function OrganizationOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'students_active': json['students_active'],
        'staff_active': json['staff_active'],
        'classes': json['classes'],
        'workshops_this_week': json['workshops_this_week'],
        'workshops_next_week': json['workshops_next_week'],
        'attendance_30d': AttendanceSummaryFromJSON(json['attendance_30d']),
        'license': LicenseSummaryFromJSON(json['license']),
        'recent_workshops': json['recent_workshops'] == null ? undefined : ((json['recent_workshops'] as Array<any>).map(WorkshopBriefFromJSON)),
    };
}

export function OrganizationOverviewToJSON(json: any): OrganizationOverview {
    return OrganizationOverviewToJSONTyped(json, false);
}

export function OrganizationOverviewToJSONTyped(value?: OrganizationOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'students_active': value['students_active'],
        'staff_active': value['staff_active'],
        'classes': value['classes'],
        'workshops_this_week': value['workshops_this_week'],
        'workshops_next_week': value['workshops_next_week'],
        'attendance_30d': AttendanceSummaryToJSON(value['attendance_30d']),
        'license': LicenseSummaryToJSON(value['license']),
        'recent_workshops': value['recent_workshops'] == null ? undefined : ((value['recent_workshops'] as Array<any>).map(WorkshopBriefToJSON)),
    };
}

